import { render } from "./page-form-maintenance.vue?vue&type=template&id=cf767022&scoped=true"
import script from "./page-form-maintenance.vue?vue&type=script&lang=js"
export * from "./page-form-maintenance.vue?vue&type=script&lang=js"

import "./page-form-maintenance.vue?vue&type=style&index=0&id=cf767022&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf767022"],['__file',"src/components/notepad/pages/page-form-maintenance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cf767022"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cf767022', __exports__)) {
    api.reload('cf767022', __exports__)
  }
  
  module.hot.accept("./page-form-maintenance.vue?vue&type=template&id=cf767022&scoped=true", () => {
    api.rerender('cf767022', render)
  })

}


export default __exports__